import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestModel } from '../typings/typing';
@Injectable({
  providedIn: 'root'
})
export class DealerPortalService {

  prefix = '/dealer_portal';
  constructor(private http: HttpClient) { }

  // Get dashboard target info
  getDashboardTarget() {
    return this.http.get<RequestModel>(
      this.prefix + '/dealer/dashboard/target/get',
    );
  }

  // Get dashboard cbf dictionary
  getDashboardCbfDictionary() {
    return this.http.get<RequestModel>(
      this.prefix + '/dealer/dashboard/cbf/get',
    );
  }
  // Get dashboard Split CBF List
  getDashboardSplitList(params: any) {
    return this.http.get<RequestModel>(
      this.prefix + '/dealer/dashboard/target/split/get',
      {
        params
      },
    );
  }

  getMainContractAnnualTargetAchieve(params: any) {
    return this.http.get<RequestModel>(
      this.prefix + '/target-ach/main-contract-annual-target-achieve',
      {
        params
      },
    );
  }
  getAnnualCbfTargetAndPurchase(params: any) {
    return this.http.get<RequestModel>(
      this.prefix + '/target-ach/annual-cbf-target-and-purchase',
      {
        params
      },
    );
  }

  getMarketingProcessFee(params: any) {
    return this.http.post<RequestModel>(
      this.prefix + '/target-ach/marketing-process-fee/list', params);
  }

  getMarketingFeeTotalAmount(params: any) {
    return this.http.post<RequestModel>(
      this.prefix + '/target-ach/marketing-process-fee/total-amount', params);
  }

  getFeeFilterList() {
    return this.http.post<RequestModel>(
      this.prefix + '/target-ach/marketing-process-fee/filter-list', {});
  }

  getMarketingProcessMaterial(params: any) {
    return this.http.post<RequestModel>(
      this.prefix + '/target-ach/marketing-process-material/list', params);
  }

  getMaterialFilterList() {
    return this.http.post<RequestModel>(
      this.prefix + '/target-ach/marketing-process-material/filter-list', {});
  }

  syncMarketingStatus(params: any) {
    return this.http.post<RequestModel>(
      this.prefix + '/target-ach/sync-marketing-status', params);
  }

  /** 首页订单追踪汇总（Dealer Homepage / getOrderSummary） */
  getOrderSummary() {
    return this.http.get<RequestModel>(
      this.prefix + '/dealer/homepage/order-summary/get');
  }

  /** 当前客户促销活动汇总，params 可传请求来源（如 { type: 'popwindow' }） */
  getPromotionActivitySummary(params?: any) {
    return this.http.get<RequestModel>(
      this.prefix + '/promotion/front/activity-summary',
      {
        params
      });
  }

  /**
   * 当前客户历史（已结束）促销活动摘要，分页查询。
   * POST 体：{ current, size, param: { activityName } }；activityName 支持模糊查询。
   */
  getPromotionHistoryActivitySummary(current: number, size: number, activityName?: string) {
    return this.http.post<RequestModel>(
      this.prefix + '/promotion/front/history/activity-summary',
      {
        current,
        size,
        param: activityName ? { activityName } : {}
      });
  }

  /** 根据活动ID列表查询关联的料号 */
  queryActivityPartNos(activityIds: number[]) {
    return this.http.post<RequestModel>(
      this.prefix + '/promotion/front/activity/part-no/list', { activityIds });
  }

  /**
   * 促销活动前台 - 校验传入料号归属于传入活动后，调用 ecat 全局料号列表接口。
   * POST /promotion/front/part/global/part-nos/list
   */
  queryGlobalPartNos(partNos: string[], activityIds: number[], page?: number, pageSize?: number) {
    return this.http.post<RequestModel>(
      this.prefix + '/promotion/front/part/global/part-nos/list',
      { partNos, activityIds, page, pageSize });
  }

  /** 查询当前客户指定活动的卡券核销记录 */
  getPromotionRedeemRecords(activityId: number) {
    return this.http.get<RequestModel>(
      this.prefix + `/promotion/front/activity/${activityId}/redeem-records`);
  }
}
